import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { GetWeekDetails } from '../../core/my-journal.selector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-weeks-heading',
  templateUrl: './weeks-heading.component.html',
  styleUrls: ['./weeks-heading.component.css']
})
export class WeeksHeadingComponent {

  weekDetails: any;

  loading: boolean = false;
  sessionDetails = null;
  weekNumber:any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private store: Store, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe((params:any)=>{
      if(params?.params?.weekNumber){
        this.weekNumber = params?.params?.weekNumber
      }
    })
    this.store.select(GetWeekDetails).pipe(takeUntil(this.onDestroy)).subscribe(weekDetails => {
      this.loading = weekDetails.loading;
      if (weekDetails?.details?.sessionData) {
        const sessionLength = weekDetails?.details?.sessionData.length
        this.sessionDetails = weekDetails.details.sessionData[sessionLength - 1];
      }
      this.weekDetails = weekDetails?.details;
    })
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
